export default class GetLocationByIdError extends Error {

}